import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Programs from "@/pages/Programs";
import ProgramDetail from "@/pages/ProgramDetail";
import CreateProgram from "@/pages/CreateProgram";
import Notifications from "@/pages/Notifications";
import AdminUsers from "@/pages/AdminUsers";
import AdminClients from "@/pages/AdminClients";
import AdminFaculty from "@/pages/AdminFaculty";
import AdminSkills from "@/pages/AdminSkills";
import AdminInfra from "@/pages/AdminInfra";
import AdminSoftware from "@/pages/AdminSoftware";
import Reports from "@/pages/Reports";
import "@/App.css";

function withLayout(node) {
  return (
    <ProtectedRoute>
      <Layout>{node}</Layout>
    </ProtectedRoute>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster richColors position="top-right" />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={withLayout(<Dashboard />)} />
          <Route path="/programs" element={withLayout(<Programs />)} />
          <Route path="/programs/new" element={
            <ProtectedRoute roles={["bd", "admin"]}>
              <Layout><CreateProgram /></Layout>
            </ProtectedRoute>
          } />
          <Route path="/programs/:id" element={withLayout(<ProgramDetail />)} />
          <Route path="/notifications" element={withLayout(<Notifications />)} />
          <Route path="/admin/users" element={
            <ProtectedRoute roles={["admin"]}>
              <Layout><AdminUsers /></Layout>
            </ProtectedRoute>
          } />
          <Route path="/admin/clients" element={
            <ProtectedRoute roles={["admin", "bd"]}>
              <Layout><AdminClients /></Layout>
            </ProtectedRoute>
          } />
          <Route path="/admin/faculty" element={
            <ProtectedRoute roles={["admin", "pm"]}>
              <Layout><AdminFaculty /></Layout>
            </ProtectedRoute>
          } />
          <Route path="/admin/skills" element={
            <ProtectedRoute roles={["admin"]}>
              <Layout><AdminSkills /></Layout>
            </ProtectedRoute>
          } />
          <Route path="/admin/infra" element={
            <ProtectedRoute roles={["admin"]}>
              <Layout><AdminInfra /></Layout>
            </ProtectedRoute>
          } />
          <Route path="/admin/software" element={
            <ProtectedRoute roles={["admin"]}>
              <Layout><AdminSoftware /></Layout>
            </ProtectedRoute>
          } />
          <Route path="/reports" element={
            <ProtectedRoute roles={["admin", "bd"]}>
              <Layout><Reports /></Layout>
            </ProtectedRoute>
          } />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
